import React from 'react';
import { FacebookShareButton } from 'react-share';

import fbLogoIcon from '../../public/images/icons/round-facebook-icon.png';

import styles from './FbShareSection.module.scss';

const { 'fb-share-section': fbShareSectionClass, 'share-button': shareButtonClass } = styles;

const FbShareSection = ({ shareUrl, customClass }) => {
  const handleShare = () => {
    window.FB &&
      window.FB.ui(
        {
          method: 'share',
          href: shareUrl
        },
        function(response) {}
      );
  };

  return (
    <div className={`${fbShareSectionClass} ${customClass}`}>
      <img src={fbLogoIcon} />
      <h3>Share these details to Facebook</h3>
      <p>
        Help notify others and give them a chance to share their support and memories on Everdays.
      </p>
      <div className={shareButtonClass}>
        <FacebookShareButton url={shareUrl}>Post Now</FacebookShareButton>
      </div>
    </div>
  );
};

export default FbShareSection;
